<template>
  <footer
    class="ten-footer"
    :style="_footerStyle"
    v-bind="$attrs"
  >
    <!-- @slot Footer 内容 -->
    <slot />
  </footer>
</template>

<script>
const name = 'ten-footer';
export default {
  name,
  props: {
    /**
     * 底部 footer 高度
     */
    height: {
      type: [Number, String],
      default: 72,
    },
  },
  computed: {
    _footerStyle() {
      return {
        height: `${this.height}px`,
      };
    },
  },
};
</script>
